/**
 * @fileoverview Google Signup Success Modal
 * @description Modal shown after Google signup to redirect user to home
 */

import { useTranslation } from 'react-i18next'
import { Modal, Text, Button, Stack, Center } from '@mantine/core'
import { IconCircleCheck } from '@tabler/icons-react'

interface GoogleSignupSuccessModalProps {
  opened: boolean
  onClose: () => void
}

/**
 * Modal shown after successful Google signup
 * Redirects user to home page since email is already verified by Google
 */
export const GoogleSignupSuccessModal = ({
  opened,
  onClose,
}: GoogleSignupSuccessModalProps) => {
  const { t } = useTranslation()

  const handleGoToHome = () => {
    window.location.href = '/'
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('teacher_signup.google_success_title')}
      centered
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      size="md"
    >
      <Stack spacing="lg">
        <Center>
          <IconCircleCheck size={64} color="teal" stroke={1.5} />
        </Center>

        <Text align="center" size="md">
          {t('teacher_signup.google_success_description')}
        </Text>

        <Text align="center" size="sm" color="dimmed">
          {t('teacher_signup.google_success_ready')}
        </Text>

        <Button
          fullWidth
          size="lg"
          color="teal"
          onClick={handleGoToHome}
        >
          {t('teacher_signup.go_to_home')}
        </Button>
      </Stack>
    </Modal>
  )
}
